export default {
  navTheme: 'dark',
  // logo: 'https://preview.pro.ant.design/static/logo.f0355d39.svg',
  //logo: "/img/AutosledLogo.png",
  primaryColor: '#2d6ac4',
  layout: 'sidemenu',
  contentWidth: 'Fluid',
  fixedHeader: false,
  autoHideHeader: false,
  fixSiderbar: false,
  colorWeak: false,
  menu: {
    locale: false,
  },
  title: 'AUTOSLED',
  pwa: false,
  iconfontUrl: '',
};
